// extracted by mini-css-extract-plugin
export default {"page":"PlaceholderPage_page__c2JAq","page_transition":"PlaceholderPage_page_transition__+tuPE"};